import { render, staticRenderFns } from "./dept-select.vue?vue&type=template&id=7556795c&"
import script from "./dept-select.vue?vue&type=script&lang=js&"
export * from "./dept-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports